import { Button } from 'react-bootstrap';
import React from 'react';
import Styles from './dashboardSection.module.scss';
import dashboardImage from '../../assets/dashboard.webp';
import { useNavigate } from 'react-router-dom';

const DashboardSection = () => {
  const navigate = useNavigate();
  const navigateToDashboard = () => {
		navigate('/dashboard');
	}
  return (
    <div className={Styles.informationSec}>
      <div className={Styles.textContainer}>
        <div className={Styles.informationSecText}>
            <h1>Dashboard</h1>
            <p>
            Explore real-time Air Quality Index (AQI) data for your location on our interactive maps. We provide comprehensive information about air quality, including levels of pollutants like Nitrogen dioxide, Carbon monoxide, sulfur dioxide, and more. Stay informed about the air you breathe and its potential impact on health.
            </p>
            <Button variant="secondary" className={Styles.informationSecButton} onClick={navigateToDashboard}>
              Try Now
            </Button>
          </div>
        </div>
        <div className={Styles.image}>
          <img className={Styles.informationSecImage} src={dashboardImage} alt="Dashboard" />
        </div>
      </div>
  );
};

export { DashboardSection };
